// Capabilities
export const ADD_CAPABILITY = 'ADD_CAPABILITY';
export const UPDATE_CAPABILITY_DESCR = 'UPDATE_CAPABILITY_DESCR';
export const DELETE_CAPABILITY = 'DELETE_CAPABILITY';

// Properties
export const UPDATE_SUPPORTED_API = 'UPDATE_SUPPORTED_API';
export const TOGGLE_AUTH_TYPE = 'TOGGLE_AUTH_TYPE';
export const UPDATE_AUTH_TYPE = 'UPDATE_AUTH_TYPE';
export const UPDATE_CONF_TOKEN = 'UPDATE_CONF_TOKEN';
export const TOGGLE_ALGORITHM = 'TOGGLE_ALGORITHM';
export const TOGGLE_URL = 'TOGGLE_URL';
export const UPDATE_URL = 'UPDATE_URL';

// Content
export const UPDATE_SINGLE_INPUT = 'UPDATE_SINGLE_INPUT';
export const UPDATE_FlAGS = 'UPDATE_FlAGS';
export const LOAD_FILE = 'LOAD_FILE';
export const DELETE_LOGO = 'DELETE_LOGO';

// Configuration Spec
export const ADD_CONF_SPEC = 'ADD_CONF_SPEC';
export const ADD_OPTIONS = 'ADD_OPTIONS';
export const DELETE_CONF_SPEC = 'DELETE_CONF_SPEC';
export const DELETE_ALL_OPTIONS = 'DELETE_ALL_OPTIONS';
export const DELETE_OPTION = 'DELETE_OPTION';
export const UPDATE_CONF_SPEC = 'UPDATE_CONF_SPEC';
export const UPDATE_OPTION = 'UPDATE_OPTION';

// External References
export const UPDATE_EXTERNAL_REFERENCE = 'UPDATE_EXTERNAL_REFERENCE';
export const ADD_EXTERNAL_REFERENCE = 'ADD_EXTERNAL_REFERENCE';
export const DELETE_EXTERNAL_REFERENCE = 'DELETE_EXTERNAL_REFERENCE';

// Root
export const READ_STATE_FROM_BACKEND = 'READ_STATE_FROM_BACKEND';
export const SAVE_PATCH_BASE = 'SAVE_PATCH_BASE';

export const PULL_MODULE_TYPE_REQUEST = 'PULL_MODULE_TYPE_REQUEST';
export const PUSH_MODULE_TYPE_REQUEST = 'PUSH_MODULE_TYPE_REQUEST';
export const PATCH_MODULE_TYPE_REQUEST = 'PATCH_MODULE_TYPE_REQUEST';

export const PULL_MODULE_TYPE_SUCCESS = 'PULL_MODULE_TYPE_SUCCESS';
export const PUSH_MODULE_TYPE_SUCCESS = 'PUSH_MODULE_TYPE_SUCCESS';
export const PATCH_MODULE_TYPE_SUCCESS = 'PATCH_MODULE_TYPE_SUCCESS';

export const PULL_MODULE_TYPE_ERROR = 'PULL_MODULE_TYPE_ERROR';
export const PUSH_MODULE_TYPE_ERROR = 'PUSH_MODULE_TYPE_ERROR';

// Visibility
export const SHOW_MODAL_FOR_PUSH = "SHOW_MODAL_FOR_PUSH";
export const HIDE_MODAL_FOR_PUSH = "HIDE_MODAL_FOR_PUSH";

export const SHOW_MODAL_FOR_PATCH = "SHOW_MODAL_FOR_PATCH";
export const HIDE_MODAL_FOR_PATCH = "HIDE_MODAL_FOR_PATCH";

export const SHOW_ALERT = "SHOW_ALERT";
export const HIDE_ALERT = "HIDE_ALERT";

export const SHOW_CONFIRM_BOX = "SHOW_CONFIRM_BOX";
export const HIDE_CONFIRM_BOX = "HIDE_CONFIRM_BOX";

export const SHOW_LOADER = "SHOW_LOADER";
export const HIDE_LOADER = "HIDE_LOADER";

export const SHOW_MODAL_FOR_PULL = "SHOW_MODAL_FOR_PULL";
export const HIDE_MODAL_FOR_PULL = "HIDE_MODAL_FOR_PULL";

export const ACTIVATE_PATCH = "ACTIVATE_PATCH";
export const DEACTIVATE_PATCH = "DEACTIVATE_PATCH";
